import React from 'react';
import { styled } from 'styled-components';
import { Card } from './Card';
import { PageTitle } from './PageTitle';
import { PageDescription } from './PageDescription';
import { StandardSection, StandardSectionContentContainer } from './StandardSection';
import { CardContainer } from './CardContainer';
import jokerImage from '../images/parts/joker.webp';

const PartCard = styled(Card)`
    @media only screen and (min-width: ${(props) => props.theme.breakpoints.second}) {
        flex: 1 1 50%;
    }
`;

export const PartsSection = () => (
    <StandardSection>
        <StandardSectionContentContainer>
            <PageTitle>Parts</PageTitle>
			<PageDescription>
				Open source parts that you can freely print and use. You can even tweak them to your liking.
			</PageDescription>
            <CardContainer>
                <PartCard 
                    to="/parts/joker" 
                    background={jokerImage} 
                    title="Joker" 
                    description="An ultralight tinywhoop racing canopy."
                />
            </CardContainer>
        </StandardSectionContentContainer>
    </StandardSection>
);